import {
    UPDATE_INPUT_NEW_CAR,
    SUBMIT_NEW_CAR,
} from '../actions/types';

let defaultNewCar = {
    name: '',
};

export default function (state = {}, action) {
    switch (action.type) {
        case UPDATE_INPUT_NEW_CAR:
            return action.payload;
        case SUBMIT_NEW_CAR:
            return defaultNewCar;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/app/reducers/new_car_reducer.js